module.exports = __webpack_public_path__ + "static/sprinks223-997705641d60ca04ecfab0458df043b0.svg";